import {createContext} from 'react';


export const QuestionAnswers = createContext({});
export const UserData = createContext();
export const ProgressesStatus = createContext();
export const CurrentState = createContext();
